import React, { Component } from "react";
import "regenerator-runtime/runtime";

import "./index.scss";

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cartFetch: {
        orders: [],
        total: 0,
      },
      stateCount: false,
      email: "",
      password: "",
      isLoggedIn: false,
      fail: false,
      menu: false,
      myAccount: false,
      overlay: false,
      mobileMenu: false,
      getStarted: false,
      community: true,
      stock: true,
      custom: true,
      validationAdvice: `Sorry, unable to login. Please try again.`,
      cartLoadedFetch: false,
    };

    this.loggedIn = this.loggedIn.bind(this);
    this.loadCart = this.loadCart.bind(this);
    this.login = this.login.bind(this);
    this.setEmail = this.setEmail.bind(this);
    this.setPassword = this.setPassword.bind(this);
    this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
    this.setMenu = this.setMenu.bind(this);
    this.setMobileMenu = this.setMobileMenu.bind(this);
    this.setMyAccount = this.setMyAccount.bind(this);
    this.setOverlay = this.setOverlay.bind(this);
    this.toggleGetStarted = this.toggleGetStarted.bind(this);
    this.toggleCommunity = this.toggleCommunity.bind(this);
    this.toggleStock = this.toggleStock.bind(this);
    this.toggleCustom = this.toggleCustom.bind(this);
  }

  setMobileMenu(mobileMenu) {
    this.setState({ mobileMenu });
  }

  toggleMobileMenu() {
    this.setState({ mobileMenu: !this.state.mobileMenu });
  }

  toggleGetStarted() {
    this.setState({
      getStarted: !this.state.getStarted,
      community: true,
      stock: true,
      custom: true,
    });
  }

  toggleCommunity() {
    this.setState({ community: !this.state.community });
  }

  toggleStock() {
    this.setState({ stock: !this.state.stock });
  }

  toggleCustom() {
    this.setState({ custom: !this.state.custom });
  }

  setMenu(menu) {
    this.setState({ menu });
  }

  setMyAccount(myAccount) {
    this.setState({ myAccount });
  }

  setOverlay(overlay) {
    this.setState({ overlay });
  }

  componentDidMount() {
    if(!window.isElbrusHeadLess){
      this.loadCart(false);
      this.loggedIn();  
    }
    const scriptTag = document.createElement("script");
    scriptTag.innerHTML = `
      !function (w, d, t) {
        w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
      
      
        ttq.load('C14SGI2QV147BSLC4B90');
        ttq.page();
      }(window, document, 'ttq');
    `;
    if (
      typeof window !== `undefined` &&
      (window.location.origin === "https://dev.noissue.co" ||
        window.location.origin === "http://localhost:8000")
    ) {
    } else {
      document.head.appendChild(scriptTag);
    }
  }

  loggedIn = () => {
    const { userloggedIn = false } = this.props;

    if (userloggedIn) {
      this.setState({ isLoggedIn: true });
    } else {
      fetch(`/cart-is-login/`, {
        mode: "no-cors",
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      })
        .then((response) => response.text())
        .then((data) => {
          if (data === "true") {
            this.setState({ isLoggedIn: true });
            this.loadCart(true);
          } else {
            this.setState({ isLoggedIn: false });
          }
          this.forceUpdate();
        });
    }
  };

  loadCart(updateCount) {
    let { cart = false } = this.props;

    if (cart) {
      this.setState({
        cart,
      });
    } else {
      fetch(`/cart-api/`, {
        mode: "no-cors",
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      })
        .then((response) => response.json())
        .then((resp) => {
          const cartFetch = resp;

          this.setState({
            cartFetch,
            cartLoadedFetch: true,
          });

          if (updateCount) {
            const cartCount = document.querySelector(
              ".ni-header .ni-cart-count"
            );

            if (cartCount) {
              cartCount.innerHTML = cartFetch.orders.length;
            }
          }
        });
    }
  }

  login = (email, password) => {
    const dataF = new FormData();

    if (email.trim() === "" || password.trim() === "") {
      this.setState({
        fail: true,
        validationAdvice: "Required",
      });
      return false;
    }

    dataF.append("login", JSON.stringify({ e: email, p: password }));

    fetch("/cart-pw/", {
      method: "POST",
      body: dataF,
      mode: "no-cors",
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    })
      .then((response) => response.text())
      .then((data) => {
        if (data === "true") {
          this.setState({ myAccount: false, isLoggedIn: true });
        } else {
          this.setState({
            fail: true,
            validationAdvice: "Sorry, unable to login. Please try again.",
          });

          console.error("Error1:", data);
        }
      })
      .catch((error) => {
        this.setState({
          fail: true,
          validationAdvice: "Sorry, unable to login. Please try again.",
        });

        console.error("Error:", error);
      });
  };

  setEmail = (email) => {
    this.setState({ email });
  };

  setPassword = (password) => {
    this.setState({ password });
  };

  render() {
    //return null for Header , next step is to remove all the files.
    return null;
  }
}

export default Header;
